/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsIwtcards = {
    init: function ($section) {
      const $iwtSlider = $section.find('[data-slider]');
      const cellCount = $iwtSlider.find('.card').length;
      $iwtSlider.flickity({
       // lazyLoad: 2,
        freeScroll: false,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: cellCount > 3,
        pageDots: false,
        contain: false,
        loop: true,
        prevNextButtons: true,
        initialIndex: 0,
        arrowShape: arrowShape
      });

      // Resize flickity when the slider is settled
      $iwtSlider.on('settle.flickity', function () {
        $iwtSlider.flickity('resize');
      });


    },
    blockSelect: function ($section, blockId) {
      const $iwtSlider = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $iwtSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');

    }
  }

  /******/
})()
  ;